import { useEffect, useState } from 'react';
import Header from './components/Header';
import Hero from './components/Hero';
import HotBoard from './components/HotBoard';
import TrendFeed from './components/TrendFeed';
import FeatureReads from './components/FeatureReads';
import RankBoard from './components/RankBoard';
import TimelineSection from './components/TimelineSection';
import FaqSection from './components/FaqSection';
import AboutSection from './components/AboutSection';
import Footer from './components/Footer';

export default function Home() {
  const [query, setQuery] = useState('');
  const [showTop, setShowTop] = useState(false);

  useEffect(() => {
    const onScroll = () => setShowTop(window.scrollY > 600);
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  const applyTopic = (label: string) => setQuery(label);

  return (
    <main id="site" className="min-h-screen bg-background-50 font-sans">
      <Header query={query} onQuery={setQuery} />
      <Hero onTopic={applyTopic} />
      <HotBoard onTopic={applyTopic} />
      <TrendFeed query={query} />
      <FeatureReads />
      <RankBoard />
      <TimelineSection />
      <FaqSection />
      <AboutSection />
      <Footer />

      {/* back to top */}
      <a
        href="#top"
        aria-label="回到顶部"
        className={`fixed bottom-6 right-6 z-40 flex h-11 w-11 items-center justify-center rounded-full bg-primary-500 text-background-50 shadow-lg transition-all duration-300 hover:bg-primary-600 ${
          showTop ? 'translate-y-0 opacity-100' : 'pointer-events-none translate-y-4 opacity-0'
        }`}
      >
        <i className="ri-arrow-up-line text-lg"></i>
      </a>
    </main>
  );
}